import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Inspections Components
import { FillInspectionComponent } from './fill-inspection/fill-inspection.component';
import { QuestionsComponent } from './generic-question/questions/questions.component';
import { InspectionHistoryComponent } from './inspection-history/inspection-history.component';
import { InspectionFormComponent } from './inspection-form/inspection-form.component';
import { InspectionFormDetailComponent } from './inspection-form/inspection-form-detail/inspection-form-detail.component';
import { GenericQuestionComponent } from './generic-question/generic-question.component';
import { ModalGenericQuestionComponent } from './generic-question/modal-generic-question/modal-generic-question.component';
import { ModalEquipmentFormComponent } from './inspection-form/modal-equipment-form/modal-equipment-form.component';
import { QuestionsBankComponent } from './questions-bank/questions-bank.component';

const InspectionsComponents = [
  FillInspectionComponent,
  QuestionsComponent,
  InspectionHistoryComponent,
  InspectionFormComponent,
  InspectionFormDetailComponent,
  GenericQuestionComponent,
  ModalGenericQuestionComponent,
  ModalEquipmentFormComponent,
  QuestionsBankComponent
];

@NgModule({
  declarations: InspectionsComponents,
  imports: [SharedModule],
  exports: InspectionsComponents
})
export class InspectionsModule { }
